import CustomButton from "@/components/CustomButton";
import { IS_PRODUCTION } from "@/constants/constants";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useSGPrint } from "@/hooks/useSGPrint";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

export default function PrintStrategicGuideButton() {
  const { mutateAsync: downloadAsync, error: printErrorMsg } = useSGPrint();
  const {
    household,
    header: { isError },
  } = useAppSelector((state) => state.household);

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode,
    tabName: "Strategic Guide",
  });

  const toastMessages = {
    pending: "Downloading strategic guide..",
    success: "strategic guide downloaded!",
    error:
      printErrorMsg instanceof AxiosError
        ? printErrorMsg.message
        : "Downloading strategic guide failed",
  };

  if (IS_PRODUCTION || isError) return null;

  return (
    <div>
      <CustomButton
        className="screen:mt-4 print:hidden"
        text={"Print to PDF"}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              id: household?.externalCode,
              fileName,
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
